import { IBreadcrumbItem } from "@fluentui/react";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DisplayAPIsException from "../BasicComponents/DisplayAPIsExceptionAlert";
import { CustomBreadcrumb } from "../SharedComponents/CustomBreadcrumb";
import { PRODUCT_VIEW_STYLES as styles } from "../components/ProductView/Common/ProductView.styles";
import { AISummaryCardContainer } from "../components/ProductView/Containers/ProductList/Containers/AISummaryCardContainer";
import { ProductFamilySelector } from "../components/ProductView/Containers/ProductList/Containers/ProductFamilySelector";
import { ProductListCardsContainer } from "../components/ProductView/Containers/ProductList/Containers/ProductListCardsContainer";
import { logPageView } from "../helper/AppInsightsHelper";
import { useGetProductExploreDataQuery } from "../slices/ExploreProducts.slice";

export const ExploreProducts = () => {
  const navigate = useNavigate();
  const { error, isLoading } = useGetProductExploreDataQuery(null);
  const breadcrumbProps = {
    items: [
      { text: "Home", key: "explore-products-to-home", onClick: () => navigate("/") },
      { text: "Explore Products", key: "explore-products-list" }
    ] as IBreadcrumbItem[],
    styles: styles.PRODUCT_PAGE.CSS_STYLES.productViewCustomBreadcrumb
  };

  const [selectedFamily, setSelectedFamily] = useState("Microsoft Purview");
  const productFamilyCardContainerProps = { selectedFamily, setSelectedFamily };

  const customProps = {
    selectedProductFamily: selectedFamily
  };

  useEffect(() => {
    logPageView("Explore Products Page", window.location.href, customProps);
  }, []);

  if (!isLoading && error) {
    return (
      <div className={styles.PRODUCT_PAGE.CLASS_NAMES.productPageContainer}>
        <CustomBreadcrumb {...breadcrumbProps} />
        <DisplayAPIsException error={error} height={250} />
      </div>
    );
  }

  return (
    <div className={styles.PRODUCT_PAGE.CLASS_NAMES.productPageContainer}>
      <CustomBreadcrumb {...breadcrumbProps} />
      <FluentProvider theme={webLightTheme}>
        <ProductFamilySelector {...productFamilyCardContainerProps} />
        <AISummaryCardContainer />
        <ProductListCardsContainer selectedFamily={selectedFamily} />
      </FluentProvider>
    </div>
  );
};
